// import Style from '../../../../../component/popup/style?.module.css'
import * as yup from 'yup'
import { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Snackbar } from '@mui/material'
import { FormArea, FeildWraper, SelectSearch, FeildError, FormLabel, FileUploadProgressBar } from '../../../../component/form/form-layout'
import moment from 'moment'

const UpdateRepairPopup = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, currentData, dropdown, Style, repairId }) => {
    const apiCall = useApiCall();
    const [alertData, setAlertData] = useState({ isShow: false });


    const handleClose = () => {
        setAlertData({ isShow: false })
    }

    const validationSchema = yup.object().shape({
        resolvedDate: yup.string().required('This Field is required'),
        cost: yup.string().required('This Field is required'),
        status: yup.string().required('This Field is required')
    });

    const formik = useFormik({
        initialValues: {
            resolvedDate: "",
            cost: "",
            status: ""
        },
        enableReinitialize: true,
        validationSchema,
        onSubmit: async (values) => {

            const apiData = JSON.stringify({
                "repair_id" : repairId,
                "resolved_date" : values?.resolvedDate,
                "status" : values?.status,
                "cost": values?.cost
            });

            try {
                const resp = await apiCall({ method: "post", url: `office-asset/repairs/change-status`, data: apiData });
                onSubmit(resp?.message || `Request Submitted`);
                formik.resetForm();
            } catch (error) {
                onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
            }
        }
    });

    return (
        <>
            <form onSubmit={formik.handleSubmit} className={Style?.modal_main}>
                <div className={Style?.modal_body}>
                    <FormArea>

                        <FeildWraper>
                            <FormLabel required>Resolved Date</FormLabel>
                            <input
                                type={'date'}
                                max={moment(new Date()).format("YYYY-MM-DD")}
                                name={'resolvedDate'}
                                onChange={formik.handleChange}
                                value={formik.values.resolvedDate}
                                placeholder='Asset Name'
                            />
                            {formik.touched.resolvedDate && formik.errors.resolvedDate && (
                                <FeildError>{formik.errors.resolvedDate}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Cost</FormLabel>
                            <input
                                type={'number'}
                                name={'cost'}
                                onChange={formik.handleChange}
                                value={formik.values.cost}
                                placeholder='Cost'
                            />
                            {formik.touched.cost && formik.errors.cost && (
                                <FeildError>{formik.errors.cost}</FeildError>
                            )}
                        </FeildWraper>

                        <FeildWraper>
                            <FormLabel required>Status</FormLabel>

                            <SelectSearch
                                name="status"
                                placeholder="- Select Status -"
                                onChange={(val) => {
                                    formik.setFieldValue("status", val);
                                }}
                                value={formik.values.status}
                                options={dropdown?.map((el) => ({
                                    label: el,
                                    value: el,
                                }))}
                            />
                            {formik.touched.status && formik.errors.status && (
                                <FeildError>{formik.errors.status}</FeildError>
                            )}
                        </FeildWraper>

                    </FormArea>
                </div>

                <div className={Style?.modal_foot}>
                    {/* <div className={`${Style?.dcmb__cardFoot}`}> */}
                        <button type='reset' className={`${Style?.dcmb__cancel}`} onClick={() => onClose()}>Discard</button>
                        <button type='submit' className={`${Style?.dcmb__submit}`}>Apply</button>
                    {/* </div> */}
                </div>
            </form>

            <Snackbar open={alertData?.isShow} autoHideDuration={3000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default UpdateRepairPopup